import { createSlice } from '@reduxjs/toolkit';
import { confirmSubmission } from './thunks';
import { SliceStatus } from 'type-declarations';

export interface DraftState {
	status: SliceStatus;
	isErrored: boolean;
	draftSubmitted: boolean;
}

const initialState: DraftState = {
	status: SliceStatus.IDLE,
	isErrored: false,
	draftSubmitted: false,
};

export const draftSlice = createSlice({
	name: 'draft',
	initialState,
	// Reducers to manually reset draft state
	reducers: {
		resetDraftSlice: (state) => {
			Object.assign(state, initialState);
		},
		resetDraftIsErrored: (state, action) => {
			state.isErrored = action.payload;
		},
	},
	// Thunks automatically dispatch these actions
	extraReducers: (builder) => {
		builder.addCase(confirmSubmission.pending, (state) => {
			state.status = SliceStatus.REFRESHING;
			state.isErrored = false;
		}),
			builder.addCase(confirmSubmission.fulfilled, (state) => {
				state.status = SliceStatus.SUCCEEDED;
				state.isErrored = false;
				state.draftSubmitted = true;
			}),
			builder.addCase(confirmSubmission.rejected, (state) => {
				state.status = SliceStatus.REJECTED;
				state.isErrored = true;
			});
	},
});

export const draftReducer = draftSlice.reducer;
export const draftActions = draftSlice.actions;
export const { resetDraftSlice, resetDraftIsErrored } = draftActions;
